<template>
  <!-- <v-btn
    class="mt-6"
    text
    color="error"
    @click="sheet = !sheet"
  >close</v-btn> -->
  <!-- <div class="my-3">This is a bottom sheet using the inset prop</div> -->
  
  <v-card outlined >
      <v-card-text 
        class = "pa-1 body"
      >
        <strong>          
          {{ input }}
        </strong>
      <div 
        :class = "keyboardClass"
      ></div>
    </v-card-text>
  </v-card>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
// import layout from "@/components/mongol.js";

export default {
  name  : "SimpleKeyboard",
  props : {
    keyboardClass: {
      default : "simple-keyboard",
      type    : String
    },
    input : {
      type : String
    },
    theme : String,
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard({
      onChange    : this.onChange,
      onKeyPress  : this.onKeyPress,
      theme       : this.theme, //"hg-theme-default myTheme1"
      // layout: layout
    });
    // console.log(this.keyboard, 'keyboard')
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);

    },
    onKeyPress(button) {      
      this.$emit("onKeyPress", button);


      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle   = currentLayout === "default" ? "shift" : "default";
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hg-theme-default{
        background-color: black;
}
.hg-theme-default >>>.hg-button {
    background: black;
}
</style>